module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00040-fs8.6323459.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00040-fs8.png
// module id = 193
// module chunks = 0